import FoodPrice from '@components/offer/models/FoodPrice';
import { ButtonBase, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodPriceBaseButtonProps {
    foodPrice: FoodPrice;
    onClick: (foodPrice: FoodPrice) => void;
    children: React.ReactNode;
}

const FoodPriceBaseButton: React.FC<FoodPriceBaseButtonProps> = observer(({ children, foodPrice, onClick }) => {
    var isSelected = foodPrice.isSelected;
    return (
        <ButtonBase
            onClick={() => onClick(foodPrice)}
            sx={(theme) => ({
                boxShadow: isSelected ? theme.shadows[11] : theme.shadows[9],
                // backgroundColor: isSelected ? theme.palette.secondary.light : "Background",
                p: 1.5,
                width: "25%"
            })}>
            {children}
        </ButtonBase>
    )
})

export default FoodPriceBaseButton;